export default [
  {
    path: "/field8dxNew", // 无视频
    name: "field8dxNew",
    meta: {
      title: "老板们都在用的视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/dycustom2/field8dxNew")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/zfkj.js